import { render } from "./InspectionResume.vue?vue&type=template&id=08b99601"
import script from "./InspectionResume.vue?vue&type=script&lang=js"
export * from "./InspectionResume.vue?vue&type=script&lang=js"

import exportComponent from "/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__